import type { MutationResult, OperationVariables, QueryResult } from '@apollo/client';
import type { OpenAIMutation, OpenAIQuery } from '../../../@types/OpenAI';
import type { OperationsQuery } from '../../../@types/Operations';
import type { Query } from '../../../@types/ProcessFlow';
import type { RequestState } from '../../../@types/RequestState';
import type { OperationsQueryWithStatisticsRaw } from '../usePagedStations';
import type { StationsStatsQuery } from '../usePagedStationsStats';
import type { PagedWorkOrderPlansStatsQuery } from '../usePagedWorkOrderPlansStats';
import type { WorkOrdersStatsQuery } from '../usePagedWorkOrdersStats';

export const convertToRequestState = (
  query:
    | QueryResult<Query, OperationVariables>
    | QueryResult<PagedWorkOrderPlansStatsQuery, any>
    | QueryResult<WorkOrdersStatsQuery, any>
    | QueryResult<StationsStatsQuery, any>
    | QueryResult<OperationsQueryWithStatisticsRaw, any>
    | QueryResult<OperationsQuery, OperationVariables>
    | QueryResult<OpenAIQuery, OperationVariables>
    | MutationResult<OpenAIMutation>,
): RequestState => ({
  isError: !!query.error,
  isLoading: query.loading,
  // @ts-ignore "Type instantiation is excessively deep and possibly infinite."
  isSuccess: !!query.data && !query.error && !query.loading,
});
